// @flow
import Cookies from 'js-cookie'

import jwtParser from '../utils/jwtParser'

import {
  UPDATE_HEADER,
  LOGIN_SUCCESS,
  LOGIN_FAILED,
  LOADING,
  SEARCH_POLICY_BY_TAOBAO_ID_SUCCESS,
  SEARCH_POLICY_BY_TAOBAO_ID_FAILED,
  RETURN_ITEM_ON_CHANGE,
  GET_USERS_BY_ID_SUCCESS,
  GET_USERS_BY_ID_FAILED,
  SUCCESS,
} from '../constants'


const initialState = {
  parentPath: '',
  title: '',
  user: Cookies.get('axinan-jwt') ? jwtParser(Cookies.get('axinan-jwt')) : null,
  searchError: '',
  returnRequest: {
    policy: {
      extRef: '',
      merchantComments: '',
      coverages: []
    }
  },
  loading: false,
  itemModal: {
    name: '',
    description: '',
    quantity: '',
    taobaoProductId: '',
    coverageAmount: '',
    currency: 'CNY',
    claims: [{
      claimAmount: '',
      returnQuantity: '',
      warehouseLocation: '',
      deliveryTrackingNumber: '',
    }]
  },
  resultPolicyId: '',
  userNames: {},
  success: '',
}

type InitialState = {
  parentPath: string,
  title: string,
  user?: {} | null,
  searchError: string,
  returnRequest: {
    policy: {
      extRef: string,
      merchantComments: string,
      coverages: Array<{}>
    }
  },
  loading: boolean,
  resultPolicyId: string,
  userNames: any,
  success: string,
}

function global(state: InitialState = initialState, action: { type: string, payload: any }) {
  switch (action.type) {
    case UPDATE_HEADER:
      return {
        ...state,
        ...action.payload
      }
    case LOGIN_SUCCESS:
      return {
        ...state,
        user: action.payload
      }
    case LOGIN_FAILED:
      return {
        ...state,
        error: action.payload
      }
    case RETURN_ITEM_ON_CHANGE:
      return {
        ...state,
        itemModal: action.payload
      }
    case LOADING:
      return {
        ...state,
        loading: action.payload
      }
    case SEARCH_POLICY_BY_TAOBAO_ID_SUCCESS:
      return {
        ...state,
        resultPolicyId: action.payload
      }
    case SEARCH_POLICY_BY_TAOBAO_ID_FAILED:
      return {
        ...state,
        searchError: action.payload
      }
    case GET_USERS_BY_ID_SUCCESS:
      return {
        ...state,
        userNames: action.payload
      }
    case GET_USERS_BY_ID_FAILED:
      return {
        ...state,
        userNames: {},
        error: action.payload
      }
    case SUCCESS:
      return {
        ...state,
        success: action.payload
      }
    default:
      return state
  }
}

export default global



// WEBPACK FOOTER //
// ./src/modules/global.js